import React from 'react';
import '../template-file-css/document-file-template.css';


export const GHP_BlankOrderForServices = ({ itemsRef, showErrorFor }) => {
    {/*write name of assessment inplace of "Assessment_Name"*/ }

    return <form id='GHP_BlankOrderForServices' className='file-pdf-document'> {/*write name of assessment inplace of "Assessment_Name"*/}
        <div className='file-template'>

            {/* Start HTML code from here */}

            <table>
                <tr>
                    <td className='w-375'> <span className='eleHeader'>Start Date:</span> </td>
                    <td className='w-375'> <span className='eleHeader'>End Date:</span> </td>
                </tr>
                <tr>
                    <td className='w-375'> <input type='date' id='txtStartDate' name='txtStartDate' className='add-only' /> </td>
                    <td className='w-375'> <input type='date' id='txtEndDate' name='txtEndDate' className='add-only' /> </td>
                </tr>
                <tr>
                    <td className='w-750'> <span className='eleHeader'>Name:</span> </td>
                </tr>
                <tr>
                    <td className='w-250'> <input type='text' placeholder='First Name' id='txtFirstName' name='txtFirstName' className='add-only' /> </td>
                    <td className='w-250'> <input type='text' placeholder='Middle Name' id='txtMiddleName' name='txtMiddleName' className='add-only' /> </td>
                    <td className='w-250'> <input type='text' placeholder='Last Name' id='txtLastName' name='txtLastName' className='add-only' /> </td>
                </tr>
            </table>

            <p>
                Based upon the Comprehensive (Biopsychosocial) Assessment and/or other relevant information, I
                order for the Individual to receive the following checked services:

            </p>
            <p>
                <center><b>Only check services that are being provided</b></center>

            </p>
            <table>
                <tr>
                    <td className='w-750'>
                        <span className='eleHeader'>Non-Medical Orders:(Licensed Clinician Only)</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_1" name="NonMedicalOrders_1" className="dd" value="1" /> Behavioral Health Assessment/ Service
                        Plan
                        Development
                    </td>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_2" name="NonMedicalOrders_2" className="dd" value="1" /> Crisis Intervention
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_3" name="NonMedicalOrders_3" className="dd" value="1" /> Community Support (C&A)
                    </td>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_4" name="NonMedicalOrders_4" className="dd" value="1" /> Case Management (Adults)
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_5" name="NonMedicalOrders_5" className="dd" value="1" /> Psychosocial Rehabilitation-Individual
                        (Adults)
                    </td>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_6" name="NonMedicalOrders_6" className="dd" value="1" /> Psychosocial Rehabilitation-Group
                        (Adults)
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_7" name="NonMedicalOrders_7" className="dd" value="1" /> Individual Counseling
                    </td>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_8" name="NonMedicalOrders_8" className="dd" value="1" /> Family Training/Counseling
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_9" name="NonMedicalOrders_9" className="dd" value="1" /> Group Training Counseling

                    </td>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_10" name="NonMedicalOrders_10" className="dd" value="1" /> Addictive Diseases Support Services
                        (ADSS)
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_11" name="NonMedicalOrders_11" className="dd" value="1" /> Peer Support Services-Individual
                    </td>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_12" name="NonMedicalOrders_12" className="dd" value="1" /> Peer Support Services-Group
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_13" name="NonMedicalOrders_13" className="dd" value="1" /> Peer Support Whole Health & Wellness
                    </td>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_14" name="NonMedicalOrders_14" className="dd" value="1" /> Psychological Testing
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_15" name="NonMedicalOrders_15" className="dd" value="1" /> Community Transitioning Planning
                    </td>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_16" name="NonMedicalOrders_16" className="dd" value="1" /> Diagnostic Assessment
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_17" name="NonMedicalOrders_17" className="dd" value="1" /> Coordination of Care
                    </td>
                </tr>
            </table>
            <table>
                <tr>
                    <td className='w-750'>
                        <span className='eleHeader '>Medical Order:
                            (Physician/APRN Only)</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_17" name="NonMedicalOrders_17" className="dd" value="1" /> Diagnostic Assessment (MD Only)
                    </td>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_18" name="NonMedicalOrders_18" className="dd" value="1" /> Psychiatric Care/Physician Assessment
                        (MD Only)
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_19" name="NonMedicalOrders_19" className="dd" value="1" /> Nursing Assessment/Health Services
                        (MD Only)
                    </td>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_20" name="NonMedicalOrders_20" className="dd" value="1" /> Medication Administration (MD Only)
                    </td>
                </tr>
                <tr>
                    <td className='w-375'>
                        <input type="checkbox" id="NonMedicalOrders_21" name="NonMedicalOrders_21" className="dd" value="1" /> Psychological Testing
                    </td>
                    <td className='w-375'>
                        &nbsp;
                    </td>
                </tr>
            </table>
            <p>
                <center><b>The Above Non-Medical Orders Have Been Ordered By:</b></center>
            </p>
            <table>
                <tr>
                    <td className="signature w-300">&nbsp;</td>
                    <td className="signature w-75">&nbsp;</td>
                    <td className="signature w-300">&nbsp;</td>
                    <td className="signature w-75">&nbsp;</td>
                </tr>
                <tr>
                    <td className="small w-300"> Licensed Professional Printed Name</td>
                    <td className="small w-75"> License #</td>
                    <td className="small w-300"> Licensed Professional Signature and Credentials </td>
                    <td className="small w-75"> Date</td>
                </tr>
                <tr>
                    <td className="signature w-300">&nbsp;</td>
                    <td className="signature w-75">&nbsp;</td>
                    <td className="signature w-300">&nbsp;</td>
                    <td className="signature w-75">&nbsp;</td>
                </tr>
                <tr>
                    <td className="small w-300"> Licensed Professional Printed Name</td>
                    <td className="small w-75"> License #</td>
                    <td className="small w-300"> Licensed Professional Signature and Credentials </td>
                    <td className="small w-75"> Date</td>
                </tr>
            </table>

            <p>
                <center><b>The Above Medical Orders Have Been Ordered By:</b></center>
            </p>
            <table>
                <tr>
                    <td className="signature w-300">&nbsp;</td>
                    <td className="signature w-75">&nbsp;</td>
                    <td className="signature w-300">&nbsp;</td>
                    <td className="signature w-75">&nbsp;</td>
                </tr>
                <tr>
                    <td className="small w-300"> Licensed Professional Printed Name</td>
                    <td className="small w-75"> License #</td>
                    <td className="small w-300"> Licensed Professional Signature and Credentials </td>
                    <td className="small w-75"> Date</td>
                </tr>
                <tr>
                    <td className="signature w-300">&nbsp;</td>
                    <td className="signature w-75">&nbsp;</td>
                    <td className="signature w-300">&nbsp;</td>
                    <td className="signature w-75">&nbsp;</td>
                </tr>
                <tr>
                    <td className="small w-300"> Licensed Professional Printed Name</td>
                    <td className="small w-75"> License #</td>
                    <td className="small w-300"> Licensed Professional Signature and Credentials </td>
                    <td className="small w-75"> Date</td>
                </tr>
            </table>


            {/* HTML code end here */}


        </div>
    </form >
}